const STRINGS = {
  CONTRACTOR_TYPE: "contractor",
  TRADESMAN_TYPE: "tradesman",
  HOMEOWNER_TYPE: "homeowner",
};

export default STRINGS;
